import React from 'react';
import Programs from '../components/Programs';
import Services from '../components/Services';
import Footer from '../components/Footer';

const ProgramsPage = () => {
  return (
    <div className="min-h-screen">
      {/* Programa Somos Backanas */}
      <section className="py-20">
        <Programs />
      </section>
      
      {/* Programa Somos Backanas Description */}
      <section className="py-10 px-4 bg-gray-100">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl font-bold text-fhk-orange-500 mb-4">Programa Somos Backanas</h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            El programa Somos Backanas es un programa de formación en habilidades socioemocionales y de liderazgo, así como de vinculación con el mundo de las competencias STEM. Está orientado a niñas y jóvenes de entre 16 y 18 años, cuyo anhelo es el de transformar sus vidas para no sólo impactar el entorno donde se desempeñen el día de mañana, sino también aumentar su nivel de bienestar personal al utilizar herramientas de conexión con ellas mismas.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed mt-4">
            El programa nace en Chile, al alero de comunidades vinculadas al mundo de la minería, su propósito consiste en fomentar la inclusión de mujeres en ámbitos laborales tradicionalmente masculinos, en los cuales han estado o se han sentido en desventaja. Nuestra misión es prepararlas en habilidades socioemocionales y de liderazgo, velando que no renuncien a su trayectoria como mujeres en formación.
          </p>
        </div>
      </section>

      {/* Qué ofrecemos */}
      <section id="que-ofrecemos" className="py-20">
        <Services />
      </section>
      
      <Footer />
    </div>
  );
};

export default ProgramsPage;
